import Vue from 'vue'
import DaidiLoading from '@/components/StateWidgets/daidiLoading'
import { getSingle } from '@/utils/singleton'
let DaidiLoadingConstructor = Vue.extend(DaidiLoading) // 返回扩展实例构造器

let createDaidiLoading = () => {
  let daidiLoadingDom = new DaidiLoadingConstructor({
    el: document.createElement('div') // 将daidiLoading组件挂载到新创建的div上
  })
  document.body.appendChild(daidiLoadingDom.$el) // 把daidiLoading组件的dom加入body
  return daidiLoadingDom
}

let createSingleDaidiLoading = getSingle(createDaidiLoading)

let myDaidiLoading = {}
myDaidiLoading.show = ({ text = '加载中...', options = {} } = {}) => {
  let daidiLoadingDom = createSingleDaidiLoading(text)
  daidiLoadingDom.options = Object.assign({}, daidiLoadingDom.options, options)
  daidiLoadingDom.text = text
  daidiLoadingDom.isShow = true
}
myDaidiLoading.hide = () => {
  let daidiLoadingDom = createSingleDaidiLoading()
  daidiLoadingDom.isShow = false
}

export default myDaidiLoading
